module.exports = __webpack_public_path__ + "img/utmify.048db44a.svg";